import React, { useEffect, useState, useRef } from 'react';
import './RepFeedbackToast.css';

interface RepFeedbackToastProps {
  feedback: 'success' | 'fail' | 'too_much' | null;
}

const MESSAGES = {
  success:  'On target',
  fail:     'Too light',
  too_much: 'Too heavy',
};

const RepFeedbackToast: React.FC<RepFeedbackToastProps> = ({ feedback }) => {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<'success' | 'fail' | 'too_much' | null>(null);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!feedback) return;

    // Cancel any pending hide
    if (hideTimer.current) clearTimeout(hideTimer.current);

    setCurrent(feedback);
    setVisible(true);

    hideTimer.current = setTimeout(() => {
      setVisible(false);
    }, 3000);

    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, [feedback]);

  if (!current) return null;

  return (
    <div className={`rep-feedback-toast rep-feedback-toast--${current} ${visible ? 'rep-feedback-toast--in' : 'rep-feedback-toast--out'}`}>
      <span className="rep-feedback-toast__bar" />
      <span className="rep-feedback-toast__message">{MESSAGES[current]}</span>
    </div>
  );
};

export default RepFeedbackToast;
